import { RouteObject } from 'react-router-dom';
import HomePage from '@/pages/home/page';
import ServicesPage from '@/pages/services/page';
import PlansPage from '@/pages/plans/page';
import ContactPage from '@/pages/contact/page';
import AboutPage from '@/pages/about/page';
import PrivacyPage from '@/pages/privacy/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/services', element: <ServicesPage /> },
  { path: '/plans', element: <PlansPage /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '/about', element: <AboutPage /> },
  { path: '/privacy', element: <PrivacyPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
